import { pragueParts } from '../../../shared/time.js'

/** Czech plural: 1 úsek · 2–4 úseky · 0, 5+ úseků. */
const csPlural = (n, one, few, many) => (n === 1 ? one : n >= 2 && n <= 4 ? few : many)

export const STRINGS = {
  cs: {
    appTitle: 'Zaparkuj zdarma',
    appSubtitle: 'Kde se dá v Praze zaparkovat zdarma',
    mapLabel: 'Mapa parkovacích úseků',
    panelLabel: 'Plán parkování',
    freeNow: 'Zdarma',
    paidNow: 'Placeno',

    // --- search
    searchPlaceholder: 'Hledat adresu nebo místo',
    searchCancel: 'Zrušit',
    searchShort: 'Napište alespoň 3 znaky.',
    searching: 'Hledám…',
    searchNoResults: 'Nic jsme nenašli. Zkuste jinou adresu.',
    searchFailed: 'Hledání se nepodařilo. Zkuste to znovu.',
    searchResults: (n) => `${n} ${csPlural(n, 'výsledek', 'výsledky', 'výsledků')}`,
    clearSearch: 'Vymazat hledání',
    searchShortcut: 'Klávesa / otevře hledání',

    // --- plan: how long
    stayLabel: 'Jak dlouho?',
    durationTitle: 'Vlastní délka',
    durationHint: (dur, end) => `${dur} · do ${end}`,
    stayNone: 'nezadáno',
    preset30: '30 min',
    preset1h: '1 h',
    preset2h: '2 h',
    preset3h: '3 h',
    presetNight: 'Přes noc',

    // --- plan: when
    whenLabel: 'Kdy',
    whenNow: (time) => `Teď · ${time}`,
    whenChange: 'Změnit',
    planWhenTitle: 'Kdy přijedete?',
    time: 'Čas',
    now: 'Teď',
    resetToNow: 'Zpět na teď',
    inAnHour: 'Za hodinu',
    tonight: 'Dnes 20:00',
    tomorrowMorning: 'Zítra 8:00',
    weekend: 'Víkend',
    today: 'Dnes',
    tomorrow: 'Zítra',
    prevDay: 'Předchozí den',
    nextDay: 'Další den',
    holidayPickNote: (n) => `${n} — státní svátek. Platí běžný rozvrh dne (o svátcích se od 1. 5. 2024 platí).`,

    // --- zone categories
    visitorShort: 'Návštěvnické',
    mixedShort: 'Smíšené',
    residentShort: 'Rezidentní',
    otherShort: 'Ostatní',
    resident: 'Rezidentní (modrá)',
    mixed: 'Smíšená (fialová)',
    visitor: 'Návštěvnická (oranžová)',
    other: 'Ostatní',

    // --- legend
    legendTitle: 'Legenda',
    legendNow: 'Stav úseků',
    legendPrice: (dur) => `Cena za ${dur}`,
    legendCategory: 'Typ zóny',
    legendFree: 'Zdarma',
    legendSoon: 'Do 30 min zdarma',
    legendSoonShort: 'Brzy zdarma',
    legendPaid: 'Placeno',
    heatFree: 'Zdarma',
    heatBlockedShort: 'Nelze stát',
    price: (n) => `${n} Kč`,
    priceRange: (a, b) => `${a}–${b} Kč`,
    showLegend: 'Zobrazit legendu',
    hideLegend: 'Skrýt legendu',

    // --- map layers / settings
    layersButton: 'Vrstvy a vzhled mapy',
    layersTitle: 'Mapa',
    mapTypeLabel: 'Podklad',
    basemapMinimal: 'Jednoduchá',
    basemapDetailed: 'Podrobná',
    basemapStreets: 'OSM klasická',
    basemapFallback: 'Vektorový podklad je teď nedostupný — zobrazuji klasickou mapu OSM.',
    colorBy: 'Barvy úseků',
    byStatus: 'Stav',
    byPrice: 'Cena',
    byCategory: 'Typ zóny',
    priceNeedsStay: 'Ceny uvidíte po volbě délky stání.',
    appearanceLabel: 'Vzhled',
    themeAuto: 'Systém',
    themeLight: 'Světlý',
    themeDark: 'Tmavý',
    languageLabel: 'Jazyk',

    // --- map controls
    zoomIn: 'Přiblížit',
    zoomOut: 'Oddálit',
    resetNorth: 'Natočit mapu na sever',
    locOff: 'Zobrazit moji polohu',
    locLocating: 'Hledám polohu… klepnutím zrušíte',
    locLive: 'Poloha se sleduje — klepnutím vypnete',
    locLiveHeading: 'Poloha se sleduje — klepnutím natočíte mapu podle směru jízdy',
    locHeading: 'Mapa se otáčí podle směru jízdy — klepnutím vypnete',
    locSuspended: 'Vrátit mapu na moji polohu',
    live: 'ŽIVĚ',
    locateDenied: 'Přístup k poloze je zakázaný. Povolte ho v nastavení prohlížeče.',
    locateUnavailable: 'Polohu se nepodařilo zjistit.',
    locateTimeout: 'Zjištění polohy trvá příliš dlouho. Zkuste to znovu.',
    locateUnsupported: 'Tento prohlížeč neumí sdílet polohu.',

    // --- panel chrome
    collapsePanel: 'Skrýt panel',
    expandPanel: 'Zobrazit panel',
    sheetHandle: 'Změnit velikost panelu',
    close: 'Zavřít',
    back: 'Zpět',

    // --- section card
    section: 'Úsek',
    cardFree: 'Teď zdarma',
    cardPaid: 'Teď placeno',
    cardSoon: 'Brzy zdarma',
    forStay: (dur) => `za ${dur}`,
    freeWholeStay: (dur) => `po celých ${dur}`,
    blockedTitle: 'Tady stát nelze',
    blockedSub: (h) => `Nejdelší placené stání je ${h} h.`,
    costBreak: (paid, free) => `${paid} placeno · ${free} zdarma`,
    freeUntil: (t) => `Zdarma do ${t}`,
    paidUntil: (t) => `Placeno do ${t}`,
    freeFor: (d) => `ještě ${d}`,
    paidFor: (d) => `ještě ${d}`,
    neverCharged: 'Nikdy se neplatí',
    alwaysToday: 'Bez změny v příštích dnech',
    navigate: 'Navigovat',
    pay: 'Zaplatit',
    rulesAndPrices: 'Pravidla a ceník',
    weekdaysLabel: 'Zpoplatnění',
    holidaysLabel: 'O svátcích',
    priceLabel: 'Cena',
    limitLabel: 'Limit stání',
    placesLabel: 'Počet míst',
    pricePerHour: (p) => `${p} Kč/h`,
    pricePerHourRange: (a, b) => `${a}–${b} Kč/h`,
    maxStay: (h) => `max. ${h} h`,
    holidayCapNote: 'Ve fialových a oranžových úsecích mimo celotýdenní provoz platí o svátcích strop 20–80 Kč za 24 h.',
    sourceText: 'Původní text zdroje',
    statusFree: 'Právě teď zdarma',
    statusPaid: 'Právě teď placeno',

    // --- status chips / notices
    holidayChip: 'Svátek · platí běžný rozvrh',
    holidayToday: (name) => `Svátek (${name}) — parkování není automaticky zdarma, platí běžný rozvrh.`,
    overrideChip: (label) => `Plán: ${label}`,

    // --- data / system
    loading: 'Načítám úseky…',
    errorTitle: 'Data se nepodařilo načíst',
    retry: 'Zkusit znovu',
    mapError: 'Mapu se nepodařilo zobrazit.',
    webglMissing: 'Tento prohlížeč nepodporuje WebGL, které mapa potřebuje.',
    dataSource: 'Zdroj dat',
    mapSource: 'Mapa',
    sourceLive: 'živá data',
    sourceCache: 'z mezipaměti',
    sourceSnapshot: 'snímek oficiálních dat ZPS',
    sourceMock: 'ukázková data',
    sourceVph: 'snímek oficiálních dat ZPS',
    asOf: 'stav',
    disclaimer: 'Údaje jsou orientační — vždy se řiďte dopravním značením.',
    snapshotNote: 'Snímek oficiálních dat ZPS Praha. Aktuální stav vždy ověřte podle značení.',
    hoursShort: 'h',
    minShort: 'min',
  },

  en: {
    appTitle: 'Park for Free',
    appSubtitle: 'Where to park in Prague for free',
    mapLabel: 'Map of parking sections',
    panelLabel: 'Parking plan',
    freeNow: 'Free',
    paidNow: 'Paid',

    searchPlaceholder: 'Search address or place',
    searchCancel: 'Cancel',
    searchShort: 'Type at least 3 characters.',
    searching: 'Searching…',
    searchNoResults: 'Nothing found. Try another address.',
    searchFailed: 'Search failed. Please try again.',
    searchResults: (n) => `${n} ${n === 1 ? 'result' : 'results'}`,
    clearSearch: 'Clear search',
    searchShortcut: 'Press / to search',

    stayLabel: 'How long?',
    durationTitle: 'Custom stay',
    durationHint: (dur, end) => `${dur} · until ${end}`,
    stayNone: 'not set',
    preset30: '30 min',
    preset1h: '1 h',
    preset2h: '2 h',
    preset3h: '3 h',
    presetNight: 'Overnight',

    whenLabel: 'When',
    whenNow: (time) => `Now · ${time}`,
    whenChange: 'Change',
    planWhenTitle: 'When do you arrive?',
    time: 'Time',
    now: 'Now',
    resetToNow: 'Back to now',
    inAnHour: 'In an hour',
    tonight: 'Tonight 20:00',
    tomorrowMorning: 'Tomorrow 8:00',
    weekend: 'Weekend',
    today: 'Today',
    tomorrow: 'Tomorrow',
    prevDay: 'Previous day',
    nextDay: 'Next day',
    holidayPickNote: (n) => `${n} — public holiday. The normal schedule applies (holidays are charged since 1 May 2024).`,

    visitorShort: 'Visitor',
    mixedShort: 'Mixed',
    residentShort: 'Resident',
    otherShort: 'Other',
    resident: 'Resident (blue)',
    mixed: 'Mixed (purple)',
    visitor: 'Visitor (orange)',
    other: 'Other',

    legendTitle: 'Legend',
    legendNow: 'Section status',
    legendPrice: (dur) => `Price for ${dur}`,
    legendCategory: 'Zone type',
    legendFree: 'Free',
    legendSoon: 'Free within 30 min',
    legendSoonShort: 'Free soon',
    legendPaid: 'Paid',
    heatFree: 'Free',
    heatBlockedShort: 'Not allowed',
    price: (n) => `${n} Kč`,
    priceRange: (a, b) => `${a}–${b} Kč`,
    showLegend: 'Show legend',
    hideLegend: 'Hide legend',

    layersButton: 'Map layers and appearance',
    layersTitle: 'Map',
    mapTypeLabel: 'Base map',
    basemapMinimal: 'Minimal',
    basemapDetailed: 'Detailed',
    basemapStreets: 'OSM classic',
    basemapFallback: 'The vector base map is unavailable — showing the classic OSM map.',
    colorBy: 'Section colours',
    byStatus: 'Status',
    byPrice: 'Price',
    byCategory: 'Zone type',
    priceNeedsStay: 'Pick a stay length to see prices.',
    appearanceLabel: 'Appearance',
    themeAuto: 'System',
    themeLight: 'Light',
    themeDark: 'Dark',
    languageLabel: 'Language',

    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    resetNorth: 'Reset map to north',
    locOff: 'Show my location',
    locLocating: 'Locating… tap to cancel',
    locLive: 'Following your location — tap to stop',
    locLiveHeading: 'Following your location — tap to rotate the map with your heading',
    locHeading: 'Map rotates with your heading — tap to stop',
    locSuspended: 'Back to my location',
    live: 'LIVE',
    locateDenied: 'Location access is blocked. Allow it in your browser settings.',
    locateUnavailable: 'Couldn’t find your location.',
    locateTimeout: 'Finding your location took too long. Please try again.',
    locateUnsupported: 'This browser can’t share your location.',

    collapsePanel: 'Hide panel',
    expandPanel: 'Show panel',
    sheetHandle: 'Resize panel',
    close: 'Close',
    back: 'Back',

    section: 'Section',
    cardFree: 'Free now',
    cardPaid: 'Paid now',
    cardSoon: 'Free soon',
    forStay: (dur) => `for ${dur}`,
    freeWholeStay: (dur) => `for the whole ${dur}`,
    blockedTitle: 'You can’t park here',
    blockedSub: (h) => `The longest paid stay is ${h} h.`,
    costBreak: (paid, free) => `${paid} paid · ${free} free`,
    freeUntil: (t) => `Free until ${t}`,
    paidUntil: (t) => `Paid until ${t}`,
    freeFor: (d) => `${d} more`,
    paidFor: (d) => `${d} more`,
    neverCharged: 'Never charged',
    alwaysToday: 'No change in the coming days',
    navigate: 'Navigate',
    pay: 'Pay',
    rulesAndPrices: 'Rules & prices',
    weekdaysLabel: 'Charged',
    holidaysLabel: 'Public holidays',
    priceLabel: 'Price',
    limitLabel: 'Max stay',
    placesLabel: 'Spaces',
    pricePerHour: (p) => `${p} Kč/h`,
    pricePerHourRange: (a, b) => `${a}–${b} Kč/h`,
    maxStay: (h) => `max ${h} h`,
    holidayCapNote: 'On holidays, purple and orange sections without 7-day operation cap the price at 20–80 Kč per 24 h.',
    sourceText: 'Original source text',
    statusFree: 'Free right now',
    statusPaid: 'Paid right now',

    holidayChip: 'Holiday · normal schedule',
    holidayToday: (name) => `Holiday (${name}) — not automatically free, the normal schedule applies.`,
    overrideChip: (label) => `Plan: ${label}`,

    loading: 'Loading sections…',
    errorTitle: 'Couldn’t load the data',
    retry: 'Try again',
    mapError: 'The map couldn’t be shown.',
    webglMissing: 'This browser doesn’t support WebGL, which the map needs.',
    dataSource: 'Data',
    mapSource: 'Map',
    sourceLive: 'live data',
    sourceCache: 'cached',
    sourceSnapshot: 'snapshot of official ZPS data',
    sourceMock: 'sample data',
    sourceVph: 'snapshot of official ZPS data',
    asOf: 'as of',
    disclaimer: 'Guidance only — always follow the street signs.',
    snapshotNote: 'Snapshot of official Prague ZPS data. Always check the signs on site.',
    hoursShort: 'h',
    minShort: 'min',
  },
}

export function makeT(lang) {
  const dict = STRINGS[lang] || STRINGS.cs
  return (key, ...args) => {
    const v = dict[key]
    return typeof v === 'function' ? v(...args) : v ?? key
  }
}

/** Prague wall-clock "HH:MM". */
export function pragueClock(date) {
  const p = pragueParts(date)
  return `${String(p.hour).padStart(2, '0')}:${String(p.minute).padStart(2, '0')}`
}

/** Prague "Weekday D. M." short date. */
export function pragueDateLabel(date, lang) {
  const p = pragueParts(date)
  const names =
    lang === 'en'
      ? ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      : ['', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne']
  return `${names[p.isoWeekday]} ${p.day}. ${p.month}.`
}

/** Humanize a minutes count: 200 -> "3 h 20 min", 45 -> "45 min". */
export function humanizeMinutes(min, t) {
  if (min == null) return ''
  const h = Math.floor(min / 60)
  const m = min % 60
  if (h === 0) return `${m} ${t('minShort')}`
  if (m === 0) return `${h} ${t('hoursShort')}`
  return `${h} ${t('hoursShort')} ${m} ${t('minShort')}`
}

/** A friendly transition label like "18:00" or "Po 08:00" if it's another day. */
export function transitionLabel(changesAt) {
  if (!changesAt) return ''
  if (changesAt.dayOffset === 0) return changesAt.hhmm
  return `${changesAt.weekdayLabel} ${changesAt.hhmm}`
}
